<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Question Options Group</h1>
          <p class="mt-2 text-sm text-gray-700">Details</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button @click="cancel" type="button" class="pull-right block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Back</button>
        </div>
      </div>
      <div class="mt-6 border-t border-gray-100">
        <dl class="divide-y divide-gray-100">
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">ID</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ questionOptionsGroup.id }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Name</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ questionOptionsGroup.name }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Maximum Score</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ questionOptionsGroup.max_score }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Network</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ questionOptionsGroup.network_name }}</dd>
          </div>
          <div class="px-4 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm font-medium leading-6 text-gray-900">Website</dt>
            <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ questionOptionsGroup.website_domain }}</dd>
          </div>
        </dl>
      </div>
      <div class="mb-6 border-t border-gray-100"></div>
    </div>
  </div>

  <div class="overflow-hidden rounded-lg bg-white shadow mt-4">
    <div class="px-4 py-5 sm:p-6">
      <QuestionOptionIndexComponent />
    </div>
  </div>
</template>

<script>
import QuestionOptionIndexComponent from "./QuestionOption/QuestionOptionIndexComponent.vue";

export default {
  name: "QuestionOptionsGroupShowComponent",
  data() {
    return {
      questionOptionsGroup: {
        id: null,
        name: null,
        max_score: null,
        network_name: null,
        website_domain: null,
      }
    }
  },
  computed: {
    questionOptionsGroupId() {
      return this.$route.params.id ? parseInt((this.$route.params.id)) : null;
    },
  },
  components: {
    QuestionOptionIndexComponent,
  },
  methods: {
    getOptionsGroup() {
      axios.get(`/member-firm/question-options-group/show/${this.questionOptionsGroupId}`).then((res) => {
        this.questionOptionsGroup = res.data.data;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    cancel() {
      this.$router.back();
    },
  },
  mounted() {
    if (this.questionOptionsGroupId) {
      this.getOptionsGroup();
    }
  }

}
</script>